export const API_URL = '/api';

/** Oturum çerezini her API isteğinde gönderir. */
export function apiFetch(url, options = {}) {
  return fetch(url, { ...options, credentials: 'include' }).then((res) => {
    if (
      res.status === 401 &&
      typeof url === 'string' &&
      url.includes('/api/') &&
      !url.includes('/api/auth/me') &&
      !url.includes('/api/login') &&
      !url.includes('/api/auth/verify-2fa')
    ) {
      window.dispatchEvent(new CustomEvent('marketing-auth-lost'));
    }
    return res;
  });
}

/**
 * fetch yanıtını metin olarak okur; HTML/proxy hatalarında JSON.parse patlamasını önler.
 * @returns {{ ok: boolean, data: any, rawError: string | null }}
 */
export async function parseFetchJson(res) {
  const text = await res.text();
  const trimmed = text.trim();
  if (!trimmed) {
    return {
      ok: res.ok,
      data: null,
      rawError: res.ok ? null : `Boş yanıt (HTTP ${res.status})`,
    };
  }
  if (trimmed.startsWith('<')) {
    return {
      ok: false,
      data: null,
      rawError:
        `Sunucu JSON yerine HTML döndü (HTTP ${res.status}). Backend (port 5000) çalışıyor mu ve nginx /api isteğini doğru yönlendiriyor mu kontrol edin.`,
    };
  }
  try {
    const data = JSON.parse(text);
    return { ok: res.ok, data, rawError: null };
  } catch (e) {
    return {
      ok: false,
      data: null,
      rawError: `Yanıt okunamadı: ${e.message}`,
    };
  }
}

export async function apiGet(path) {
  const res = await apiFetch(`${API_URL}${path}`);
  if (!res.ok) throw new Error(await res.text().catch(() => res.statusText));
  return res.json();
}

export async function apiPost(path, body) {
  const res = await apiFetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await res.text().catch(() => res.statusText));
  return res.json();
}
